import { render, staticRenderFns } from "./FeaturedList.vue?vue&type=template&id=29fa10fa&scoped=true&"
import script from "./FeaturedList.vue?vue&type=script&lang=js&"
export * from "./FeaturedList.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedList.vue?vue&type=style&index=0&id=29fa10fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fa10fa",
  null
  
)

export default component.exports